import { TFloorParams, TRoomsParams } from 'common/types/floor-params.type';
import { hasMatchingDimensions } from './has-matching-dimensions.helper';
import { hasMatchingArea } from './has-matching-area.helper';
import { getCalculateArea } from './calculate-area.helper';

type TGetHasSameParams = {
  dataInStorage: TRoomsParams[];
  inputParams: TFloorParams;
};

export const getHasSameParams = ({ dataInStorage, inputParams }: TGetHasSameParams): boolean => {
  const hasDimensions = inputParams?.length && inputParams?.width;

  const calculatedArea =
    inputParams?.areaUser ??
    getCalculateArea(inputParams?.length ?? undefined, inputParams?.width ?? undefined);

  return dataInStorage.some(item => {
    const itemLength = item.length ?? undefined;
    const itemWidth = item.width ?? undefined;
    const itemArea = item.square ?? getCalculateArea(itemLength, itemWidth);

    if (hasDimensions) {
      return hasMatchingDimensions(itemLength, itemWidth, inputParams?.length, inputParams?.width);
    }

    return hasMatchingArea(itemArea, calculatedArea);
  });
};
